import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { SetupMapChart, SetupMapChartCondition } from 'models/setup/SetupMapChart';

/**
 * 맵차트 기본 정보 조회
 * @param elmPrjId 설비 프로젝트ID
 */
export const findSetupMapChart = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/map-chart`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ elmPrjId }),
  };

  const response: CommonResponse<SetupMapChart> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupMapChart;
};

/**
 * 맵차트 설비 Mapping 목록 조회
 * @param condition
 */
export const findSetupMapChartList = async (condition?: SetupMapChartCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/map-chart-list`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as SetupMapChart[];
};

/**
 * 맵차트 등록
 * @param condition
 */
export const saveSetupMapChart = async (setupProjectRequest: SetupMapChart[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/map-chart`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: setupProjectRequest,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 맵차트 도면 이미지 등록
 * @param condition
 */
export const saveSetupMapChartImg = async (setupProjectRequest: SetupMapChartCondition) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/map-chart-img`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: setupProjectRequest,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 맵차트 업로드/저장 권한 조회
 * @param elmPrjId 설비 프로젝트ID
 */
export const findSetupMapChartAuth = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/map-chart/auth`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ elmPrjId }),
  };

  const response: CommonResponse<number> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as number;
};
